import { Injectable } from '@angular/core';
import { DataService } from '../data/data.service';
import { first as _first, slice as _slice, keys as _keys,
  map as _map, get as _get, includes as _includes } from 'lodash-es';
import { of, forkJoin, BehaviorSubject, Observable, from,
timer, Subject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpParams } from '@angular/common/http';
import { SourceLimit } from 'src/app/app.model';
import { CacheService } from 'src/app/cache.service';
import { AppService } from 'src/app/app.service';

@Injectable({
  providedIn: 'root'
})
export class StudioIntegrationService {


  private params = new HttpParams();
  private apiURLSuffix = `integration-setup`;
  private apiURL = `${environment.studioApiUrl}/${this.apiURLSuffix}`;
  private currentSessionState;
  private previousSessionState;
  invokeEvent: Subject<any> = new Subject();
  private selectAllTablesRows = new BehaviorSubject(false);
  currentSelectAllTablesRows = this.selectAllTablesRows.asObservable();
  private confirmedTablesData: { [key: string]: any } = {};
  private isAdvOptionsReloadAgreed = false;
  private integrationMode: string;

  constructor(private dataService: DataService, private cacheService: CacheService,
    private appService: AppService) { }

  initSetupFlowAndGetFirstStep({userId, sourceType, ...metaData}) {
    const option = {
      url: `${this.apiURL}/flows/init?userId=${userId}&dataSourceType=${sourceType}&productId=1`
    };

    return this.dataService.get(option);
  }

  initEditFlowAndGetFirstStep({userId, dataSourceType, sourceId, ...metaData}) {
    const option = {
      url: `${this.apiURL}/flows/init-edit/integrations/${sourceId}?userId=${userId}&dataSourceType=${dataSourceType}&productId=1`
    };
    return this.dataService.get(option);
  }

  updateSelectRows(updatedVal: boolean) {
    this.selectAllTablesRows.next(updatedVal);
  }

  callFunOfSelectRowsofAllTables() {
    this.invokeEvent.next();
  }

  public get userId(): number {
    return this.appService.userData.userId;
  }

  public get getIntegrationMode(): string {
    return this.integrationMode;
  }

  public set setIntegrationMode(value) {
    this.integrationMode = value;
  }

  public set setCurrentSessionState(object) {
    const { key, value } = object;
    // this.cacheService.putObject(key, value, true)
    localStorage.setItem(key, value);
    this.currentSessionState = value;
  }


  public set setPreviousSessionState(object) {
    const { key, value } = object;
    // this.cacheService.putObject(key, value, true)
    localStorage.setItem(key, value);
    this.previousSessionState = value;
  }


  public get getCurrentSessionState(): string {
    return this.currentSessionState;
  }


  public get getPreviousSessionState(): string {
    return this.previousSessionState;
  }

  public get getConfirmedTables(): any {
    return this.confirmedTablesData;
  }

  public set setConfirmedTables(object) {
    const { key, value } = object;
    this.confirmedTablesData[key] = value;
  }

  public set cleanConfirmedTables({}) {
    this.confirmedTablesData = {};
  }

  public get getAdvOptionsReloadAgreed(): any {
    return this.isAdvOptionsReloadAgreed;
  }

  public set setAdvOptionsReloadAgreed(value) {
    this.isAdvOptionsReloadAgreed = value;
  }

  getNextStep({sessionState, currentStepUserInput, userId, ...metaData}) {
    const option = {
      url: `${this.apiURL}/flows/next`,
      data: {
        sessionState,
        currentStepUserInput,
        userId
      }
    };
    return this.dataService.post(option);
  }

  getPreviousStep({sessionState, userId, ...metaData}) {
    const option = {
      url: `${this.apiURL}/flows/previous`,
      data: {
        sessionState,
        userId
      }
    };
    return this.dataService.post(option);
  }


  saveClonedConnectorStudioSource({sessionState, userId, sourceId, ...metaData}) {
    const option = {
      url: `${this.apiURL}/clone-connector-studio-source/${userId}/${sourceId}`,
      data: {
        sessionState,
        ...metaData
      }
    };
    return this.dataService.post(option);
  }

  checkSourceLimit({userId,
    dataSourceId,
    notify = true,
    actionOn = '',
    actionType = '', ...metaData}) {
      const generateUserNotification = notify ? 'true' : 'false';
        const option = {
          url: `${this.apiURL}/check-source-limit/${userId.toString()}/${dataSourceId.toString()}`,
          param: {
            notify: generateUserNotification,
            actionOn: actionOn,
            actionType: actionType
          }
        };

      return this.dataService.get(option);
  }

  initReAuth(userId: number, sourceType: string, sourceId: number) {
    const option = {
      url: `${this.apiURL}/init-re-authentication-flow-and-get-auth-step/${userId}/${sourceType}/${sourceId}`,
    };
    return this.dataService.get(option);
  }

  saveReAuth({ sessionState, userId, sourceId, eqp }) {
    const option = {
      url: `${this.apiURL}/save-re-authentication-connector-studio-source/${userId}/${sourceId}`,
      data: {
        sessionState,
        currentStepUserInput: {
          eqp: eqp
        },
        userId: userId
      }
    };
    return this.dataService.post(option);
  }
}
